import React from 'react';
import {
  TextField,
  IconButton,
  Tooltip,
  InputAdornment,
} from '@mui/material';
import {
  Search as SearchIcon,
  Clear as ClearIcon,
} from '@mui/icons-material';

interface TLookupTextFieldProps {
  label?: string;
  value?: string;
  error?: string;
  required?: boolean;
  fullWidth?: boolean;
  placeholder?: string;
  onSearchClick?: () => void;
  onClear?: () => void;
  searchTooltip?: string;
  clearTooltip?: string;
  disabled?: boolean;
}

const TLookupTextField: React.FC<TLookupTextFieldProps> = ({
  label,
  value = '',
  error,
  required = false,
  fullWidth = true,
  placeholder,
  onSearchClick,
  onClear,
  searchTooltip = 'Buscar',
  clearTooltip = 'Limpiar',
  disabled = false
}) => {
  return (
    <TextField
      label={label}
      value={value}
      error={!!error}
      helperText={error}
      required={required}
      fullWidth={fullWidth}
      placeholder={placeholder}
      disabled
      variant="outlined"
      size="small"
      InputProps={{
        endAdornment: !disabled ? (
          <InputAdornment position="end">
            {value && onClear && (
              <Tooltip title={clearTooltip}>
                <IconButton
                  onClick={onClear}
                  size="small"
                  sx={{
                    color: 'text.secondary',
                    backgroundColor: 'transparent',
                    border: 'none',
                    borderRadius: 1,
                    padding: 1,
                    mr: 0.5,
                    '&:hover': {
                      backgroundColor: 'error.main',
                      color: 'white',
                    },
                  }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onSearchClick && (
              <Tooltip title={searchTooltip}>
                <IconButton
                  onClick={onSearchClick}
                  edge="end"
                  size="small"
                  sx={{
                    color: 'primary.main',
                    backgroundColor: 'transparent',
                    border: 'none',
                    borderRadius: 1,
                    padding: 1,
                    '&:hover': {
                      backgroundColor: 'primary.main',
                      color: 'white',
                    },
                  }}
                >
                  <SearchIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </InputAdornment>
        ) : undefined,
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          backgroundColor: 'background.paper',
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'primary.main',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'primary.main',
            borderWidth: 1,
          },
        },
        '& .MuiInputLabel-root': {
          color: 'text.secondary',
          fontWeight: 500,
        },
      }}
    />
  );
};

export default TLookupTextField;